export default "__VITE_ASSET__BuPrC4GV__"